import React from 'react';

import { FineDetails, OrderSummaryText } from '../style';

type PaymentSubtotalProps = {
    item: string;
    amount: string;
    bold: boolean;
};

export default function PaymentSubtotal({ item, amount, bold }: PaymentSubtotalProps) {
    return (
        <>
            <FineDetails>
                {bold && <OrderSummaryText><strong>{item}</strong></OrderSummaryText>}
                {!bold && <OrderSummaryText>{item}</OrderSummaryText>}
                {bold && <OrderSummaryText> 
                    <strong>{amount}</strong>
                </OrderSummaryText>}
                {!bold && <OrderSummaryText> 
                    {amount}
                </OrderSummaryText>}
            </FineDetails>
        </>
    );
}
